export enum ReferralTransactionType {
  BORROWER_LOAN_ISSUED = "BORROWER_LOAN_ISSUED",
  LENDER_IDENTIFIED = "LENDER_IDENTIFIED",
  LENDER_DIVIDEND_RECEIVED = "LENDER_DIVIDEND_RECEIVED",
  LENDER_INVESTED = "LENDER_INVESTED",
  LENDER_PURCHASED = "LENDER_PURCHASED",
  WITHDRAW = "WITHDRAW",
}
